<template>
    <div>
        <BasicCard v-if="loading" v-bind:title="`Caricamento in corso`" class="pr-2">
            <v-card-text text-center>
                <v-progress-circular
                indeterminate
                size="64"
                width="7"
                color="primary"
                ></v-progress-circular>
            </v-card-text>
        </BasicCard>
        <div v-else>
            <v-hover><v-chip 
                slot-scope="{ hover }"
                :class="`caption font-weight-thin text-uppercase mb-2 ml-2 text-center elevation-${hover ? 3 : 0}`"
                @click="close" absolute top left>
                <v-icon>keyboard_arrow_left</v-icon>back</v-chip></v-hover>
            <BasicCard>
                <template v-slot:title>
                    <span v-if="master_new">Nuovo master</span>
                    <span v-else>modifica il master</span>
                </template>
                <template v-slot:action>
                    <v-btn v-if="!master_new" class="pa-2 white--text" text @click="restore"><v-icon>restore</v-icon>annulla modifiche</v-btn>
                </template>
                <v-form v-model="validityRegistry" ref="masterRegistry">
                    <v-container>
                        <v-row no-gutters>
                            <v-col cols="5"> 
                            <v-text-field dense outlined
                                label="nome*"
                                v-model="c_master.name"
                                :rules="[rules.mandatory]"
                                :readonly="preview"
                            ></v-text-field>
                            </v-col>
                            <v-col cols="4">
                            <v-autocomplete dense outlined
                                class="ml-2"    
                                :items=Object.keys(families)
                                v-model="c_master.family"
                                label="famiglia*"
                                :readonly="preview"
                                @change="selectBlocksAndProcedures"
                                :rules="[rules.mandatory]">
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="3">
                            <v-text-field dense outlined
                                class="ml-2"
                                label="revisione*"
                                :readonly="preview"
                                v-model="c_master.master_rev"
                                :rules="[rules.mandatory, used_master]"
                            ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row no-gutters v-if="c_master.family">
                            <v-col cols="7" class="col-md-5">
                                <v-autocomplete dense outlined
                                    class="d-flex flex-sm-shrink-1 flex-sm-grow-0"
                                    :items="Object.keys(families[c_master.family].report)"
                                    v-model="c_master.op_type"
                                    label="tipo operazione*"
                                    :readonly="preview"
                                    @change="selectBlocksAndProcedures"
                                    :rules="[rules.mandatory]">
                                    <template v-slot:item="{ item }">{{types[item].name}}</template>
                                    <template v-slot:selection="{ item }">{{types[item].name}}</template>
                                    </v-autocomplete>
                                </v-col>
                                <v-col cols="5">
                                    <v-checkbox label="Numero prove fissato" class="d-flex ml-6" v-model="c_master.static"></v-checkbox>
                                </v-col>
                        </v-row>
                        <v-row no-gutters>
                            <v-col cols="5" class="col-md-5">
                                <v-text-field dense outlined
                                label="Codice revisione rapporto"
                                :readonly="preview"
                                v-model="c_master.master_module"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="5" class="col-md-5 pl-2" v-if="is_VP">
                                <v-text-field dense outlined
                                label="Codice revisione attestato"
                                :readonly="preview"
                                v-model="c_master.master_mod_cert"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row no-gutters>
                            <v-col cols="5" class="col-md-5" v-if="enabledBlockSelection">
                                <v-autocomplete dense outlined
                                :items="active_procedures"
                                item-text="name"
                                item-value="_id"
                                label="Procedura"
                                :readonly="preview"
                                v-model="c_master.assigned_procedure"
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row no-gutters v-if="is_simple">
                            <v-col cols="12" class="d-flex">
                                <v-textarea dense outlined
                                label="Direttive e norme tecniche (per taratura semplificata)"
                                :readonly="preview"
                                v-model="c_master.isos_techN"
                                ></v-textarea>
                            </v-col>
                        </v-row>
                        <v-row no-gutters v-if="is_simple">
                            <v-col cols="12" class="d-flex">
                                <v-textarea dense outlined
                                label="Leggi (per taratura semplificata)"
                                :readonly="preview"
                                v-model="c_master.isos_laws"
                                ></v-textarea>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
            </BasicCard>
            <div class="d-flex flex-column" v-if="enabledBlockSelection">
                <BasicCard v-if="!preview && selectingBlock" v-bind:title="`Seleziona prove`">
                    <div class="d-flex pa-2 flex-column">
                         <v-alert class="pa-2 my-1 full-width" type="error" :value="true" v-if="dynamic_blocks_warning" >
                            Controllare blocchi dinamici
                        </v-alert>
                        <v-alert class="pa-2 my-1 full-width" type="error" :value="true" v-if="static_blocks_warning" >
                            Controllare blocchi statici
                        </v-alert>
                    </div>
                    <v-container>
                        <v-row no-gutters>
                            <v-col cols="6">    
                                <div class="ma-2 text-h6 font-weight-bold text-left">Blocchi base</div>
                                <draggable
                                    class="dragArea list-item-group elevation-12 ma-2 pa-4"
                                    :list="baseblocks"
                                    :group="{ name: 'blocks', pull: 'clone', put: false }">
                                    <v-card
                                    
                                    pa-2
                                    class="list-item ma-2"
                                    v-for="element in baseblocks"
                                    :key="element.id"
                                    >
                                    <div class="text-subtitle-1 text-center pa-2">{{ element.label }}</div>
                                    </v-card>
                                </draggable>
                            </v-col>
                            <v-col cols="6">    
                                <div class="my-2 mx-3 text-h6 font-weight-bold text-left">Prove del master <span v-if="is_conditional">dinamico</span></div>
                                <div class="my-2 mx-3 text-subtitle-1 font-italic" v-if="is_conditional">Le prove dinamiche vengono mostrate quando il pre-test non è superato</div>
                                <draggable
                                    class="dragArea list-item-group elevation-12 ma-2 pa-4"
                                    :list="selected_blocks"
                                    group="blocks">
                                    <v-card
                                    
                                    pa-2
                                    class="list-item ma-2"
                                    v-for="(element, idx) in selected_blocks"
                                    :key="element.id">
                                       <div class="d-flex text-subtitle-1 align-center justify-space-between pa-2"><div class="d-flex">{{ (idx+1) }} - {{ element.label }}</div><v-icon class="d-flex" @click="removeBlock(idx)">delete</v-icon></div>
                                    </v-card>
                                </draggable>
                                <div class="mb-2 mt-4 mx-3 text-h6 font-weight-bold text-left" v-if="is_conditional">Prove del master statico</div>
                                <div class="my-2 mx-3 text-subtitle-1 font-italic" v-if="is_conditional">Le prove statiche vengono mostrate quando il pre-test è superato</div>
                                <draggable
                                    v-if="is_conditional"
                                    class="dragArea list-item-group elevation-12 ma-2 pa-4"
                                    :list="selected_static_blocks"
                                    group="blocks">
                                    <v-card
                                    
                                    pa-2
                                    class="list-item ma-2"
                                    v-for="(element, idx) in selected_static_blocks"
                                    :key="element.id">
                                       <div class="d-flex text-subtitle-1 align-center justify-space-between pa-2"><div class="d-flex">{{ (idx+1) }} - {{ element.label }}</div><v-icon class="d-flex" @click="removeStaticBlock(idx)">delete</v-icon></div>
                                    </v-card>
                                </draggable>
                            </v-col>
                        </v-row>
                    </v-container>
                    <div class="d-flex justify-center">
                        <v-btn class="my-3" color="primary" :disabled="configurationReady" @click="saveBlocks">configura i blocchi</v-btn>
                    </div>
                </BasicCard>
                <BasicCard v-else v-bind:title="`Configurazione prove`">
                    <template v-slot:action>
                        <v-btn class="pa-2 white--text" text @click="selectingBlock=true"><v-icon>edit</v-icon>blocchi</v-btn>
                    </template>
                    <v-expansion-panels v-model="panels">
                        <div v-if="is_conditional"><span class="text-h6">Prove dinamiche</span></div>
                        <v-expansion-panel
                            v-for="(element, idx) in selected_blocks"
                            :key="element.id" >
                            <v-expansion-panel-header color="expansion" disable-icon-rotate>
                                <div class="text-subtitle-1 font-weight-bold">{{ idx+1 }} - {{ element.label }}</div>
                                <template v-slot:actions>
                                    <StatusIcon class="mx-2" :status="element.verified ? 'done' : 'failed'" :key="element.verified"/>
                                </template>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <dynamiclink type="config" :data="{'block': element, 'index': idx}" v-on:updateBlock="updateBlockConf" v-on:updateValidity="updateValidity" :preview=preview></dynamiclink>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                    <v-expansion-panels v-model="panels_static" v-if="is_conditional">
                        <div><span class="text-h6">Prove statiche</span></div>
                        <v-expansion-panel
                            v-for="(element, idx) in selected_static_blocks"
                            :key="element.id">
                            <v-expansion-panel-header color="expansion" disable-icon-rotate>
                                <div class="text-subtitle-1 font-weight-bold">{{ idx+1 }} - {{ element.label }}</div>
                                <template v-slot:actions>
                                    <StatusIcon class="mx-2" :status="element.verified ? 'done' : 'failed'" :key="element.verified"/>
                                </template>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <dynamiclink type="config" :data="{'block': element, 'index': idx}" v-on:updateBlock="updateBlockConfStatic" v-on:updateValidity="updateValidityStatic" :preview=preview></dynamiclink>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                   
                </BasicCard>
                <div class="pa-4">
                    <v-alert
                        v-if="save_error"
                        dense
                        type="warning"
                        >
                        <div class="d-flex flex-column">
                            <div class="font-weight-bold">Salvataggio fallito</div>
                            <div>Riprovare oppure segnalare il problema all'amministratore di sistema.</div>
                        </div>
                    </v-alert>
                </div>
                 <div v-if="!preview" class="d-flex justify-center my-4">
                    <v-btn color="primary" :disabled="!valid" @click="saveMaster(false)">Salva</v-btn>
                    <v-btn class="ml-2" color="primary" :disabled="!valid" @click="saveMaster(true)">Salva e attiva</v-btn>
                    <v-btn class="ml-2" text @click="close">Annulla</v-btn>
                </div>
            </div>
            
            <BaseDialog 
                :max_width="`300`"
                :dialog="show_dialog"
                title="Errore"
                v-on:close_dialog="show_dialog = false"
            >
                <p>{{dialog_description}}</p>
                <template v-slot:action>
                    <div class="d-flex align-center justify-center my-4">
                        <v-btn text v-on:click="show_dialog = false">Chiudi</v-btn>
                    </div>
                </template>
            </BaseDialog>
        </div>
    </div>
</template>
<script>

// import _ from 'lodash'
import draggable from "vuedraggable";
import dynamiclink from '../../components/utils/Block_Dynamic_link.vue'
// import {Master} from '../../utils/objectSchema.js'
import {i_families, report_type} from "../../utils/common.js"
import {getModel} from "../../utils/model"
import {f_rules} from "../../utils/commonUtils"
import BaseDialog from '../../components/dialogs/BaseDialog'
import BasicCard from '../../components/utils/Basic_card'
import StatusIcon from '../../components/utils/StatusIcon'
import { searchDesign } from '../../utils/dbUtility'


export default {
    props: {
        'm_id': {
            type: String,
            required: false,
            default: null
        },
        'clone': {
            type: Boolean,
            required: false,
            default: false
        },
        'preview': {
            type: Boolean,
            required: false,
            default: false
        }
    }, // source is the source master's db to be modified 
    components: {
        draggable, dynamiclink, BaseDialog, BasicCard, StatusIcon
    },

    data(){
        return{
            o_master: {},
            c_master: {},
            selectingBlock: true,
            families: i_families,
            rules: f_rules,
            types: report_type,
            baseblocks:[],
            selected_blocks: [],
            selected_static_blocks: [],
            panels: null,
            panels_static: null,
            show_dialog: false,
            dialog_description: '',
            last_bid: 100,
            validityRegistry: true,
            blocksValidity: false,
            loading: false,
            master_new: true,
            report_count: false,
            active_procedures: null,
            used_master: v => this.isUsedMaster(v),
            save_error: false
        }
    },
    async mounted() {
        this.loading = true
        this.selectingBlock = true
        this.o_master = {}
        this.master_new = true
        if (this.m_id) {
            let master = await this.$store.state.$pouch.get('masters', this.m_id)
            if (this.clone) {
                delete master._rev
                delete master.master_module
                delete master.master_rev
                delete master._id
                delete master.created
                delete master.updated
                delete master.name
                delete master.active
                delete master.created_by
                delete master.updated_by
                this.c_master = this.initObjectData(master)
                this.selected_blocks = master.blocks.filter(block => {
                    return block.block_type != "static"
                })
                this.selected_static_blocks = master.blocks.filter(block => {
                    return block.block_type == "static"
                })
            } else {
                // update existing master
                this.o_master = master
                let res = await searchDesign(this.$store.state.$pouch, 'reports', 'reports/searchByData', 'key', ['master', this.m_id, master.master_rev], true)
                this.report_count = (res.length > 0) ? res[0].value : 0
            
                this.c_master = _.cloneDeep(this.o_master)
                this.c_master.updated_by = this.$store.state.user._id
                this.master_new = false
                this.selectPreviousBlocks()
            }
            await this.getBaseBlocks()
            await this.getProcedures()
            this.selectingBlock = false
                
        } else {
            this.c_master = this.initObjectData({})   
        }
        this.loading = false
        this.$nextTick(function(){
            this.$refs.masterRegistry.validate()
        })
        
        // this.$refs.masterRegistry.resetValidation()
    },
    methods: {
        isUsedMaster() {
            return this.report_count==0 ? true : 'revisione già in uso'
        },
        initObjectData(data) {
            data.created_by = this.$store.state.user._id
            console.log('MASTER EDIT initObjectData')
            let Master = getModel('Master')
            let master = Master(data)
            return master
        },
        resetBlocks() {
            // this.c_master.blocks = [];
            this.selected_blocks = [];
            this.selected_static_blocks = [];
        },
        selectPreviousBlocks(){
            this.selected_blocks = this.c_master.blocks.filter((block) => {
                return block.block_type != "static"
            })
            this.selected_static_blocks = this.c_master.blocks.filter((block) => {
                return block.block_type == "static"
            })
        },
        resetInstrument() {
            this.c_master.family = null;
        },
        async getBaseBlocks() {
            
            let b_sel = {doc_type: 'baseblock'}
            if (this.c_master.family!= null && this.c_master.op_type != null) {
                b_sel['family'] = this.c_master.family
                
                let res = await this.$store.state.$pouch.find('masters', {
                    selector: b_sel, 
                    fields:['name', 'label', 'template', '_id', 'rev', '_rev', 'op_types', 'formulas', 'block_type', 'conditional']
                })
                // console.log('query', b_sel);
                let unsortedBlocks = res.docs.filter(item => {
                    return item.op_types.includes(this.c_master.op_type)  // filter to see if there is my op_type 
                });
                this.baseblocks = unsortedBlocks.sort((a,b) => {
                    if(a.block_type == b.block_type){
                        return 0
                    }
                    if(a.block_type == "general" && (b.block_type == "static" || b.block_type == "dynamic")){
                        return -1
                    }
                    if(a.block_type == "static" && (b.block_type == "general" || b.block_type == "dynamic")){
                        return 1
                    }
                    if(a.block_type == "dynamic" && b.block_type == "static"){
                        return -1
                    }
                    if(a.block_type == "dynamic" && b.block_type == "general"){
                        return 1
                    }
                })
            }
        },

        async getProcedures(){
            let b_sel = {doc_type: 'procedure'}
            if (this.c_master.family!= null && this.c_master.op_type != null) {
                b_sel['family'] = this.c_master.family
                b_sel['op_type'] = this.c_master.op_type
                b_sel['active'] = true
                let res = await this.$store.state.$pouch.find('registry', {
                    selector: b_sel, 
                    fields:['name', "_id"]
                })
                this.active_procedures = res.docs
            } 
        },

        async selectBlocksAndProcedures() {
            // select blocks from db
            if (this.c_master.family!= null && this.c_master.op_type != null) {
                await this.getBaseBlocks()
                await this.getProcedures()
                // console.log('baseblocks', this.baseblocks)
                this.c_master.blocks = []
                this.selected_blocks = []
                this.selected_static_blocks = []
                this.selectingBlock = true
            }
        },
        cloneBlock(item) {
            console.log('CLONE: ',item);
            this.last_bid += 1
            let b = _.cloneDeep(item);
            b.id = this.last_bid
            return b
        },
        removeBlock(idx) {
            this.selected_blocks.splice(idx, 1);
        },
        removeStaticBlock(idx){
            this.selected_static_blocks.splice(idx,1);
        },
        async saveBlocks(){
            for(let elem of this.selected_blocks){
                if(elem._id=="baseblock:iso:maintenance"){
                    this.c_master.maintainance = true;
                    this.$set(elem, 'verified', true)
                    console.log("trovato blocco manutenzione")
                    break;
                }
            }
            //await this.saveTempItem();
            this.selectingBlock = false
            // this.panels = [...this.c_master.blocks].map(_ => false)
            console.log("panels",this.panels)
        },
        async updateBlockConf(data){
            console.log('updateBlock', data.b_idx, data.b_id, data.conf)
            if (this.selected_blocks[data.b_idx]._id == data.b_id) {  
                this.selected_blocks[data.b_idx].conf = _.cloneDeep(data.conf);
                //this.c_master.blocks[data.b_idx].verified = true;
                this.$set(this.selected_blocks[data.b_idx], 'verified', true)
                this.panels = null
                //await this.saveTempItem();
                this.checkConfigValidity()
            }
            if(!!data.selected_mode){
                this.c_master.selected_mode = data.selected_mode
                console.log("$$ debug, added a new selection mode", data.selected_mode)
            }
        },
        async updateBlockConfStatic(data){
            console.log('updateBlock static', data.b_idx, data.b_id, data.conf)
            if (this.selected_static_blocks[data.b_idx]._id == data.b_id) {  
                this.selected_static_blocks[data.b_idx].conf = _.cloneDeep(data.conf);
                //this.c_master.blocks[data.b_idx].verified = true;
                this.$set(this.selected_static_blocks[data.b_idx], 'verified', true)
                this.panels_static = null
                //await this.saveTempItem();
                this.checkConfigValidity()
            }
            if(!!data.selected_mode){
                this.c_master.selected_mode = data.selected_mode
                console.log("$$ debug, added a new selection mode", data.selected_mode)
            }
        },
        updateValidity(data) {
            console.log('updateBlock validity', data.b_idx, data.b_id, data.conf)
            if (this.selected_blocks[data.b_idx]._id == data.b_id) {
                if (!data.valid) {
                    this.selected_blocks[data.b_idx].verified = data.valid
                }
            }
            this.checkConfigValidity()
        },
        updateValidityStatic(data) {
            console.log('updateBlock validity static', data.b_idx, data.b_id, data)
            if (this.selected_static_blocks[data.b_idx]._id == data.b_id) {
                if (!data.valid) {
                    this.selected_static_blocks[data.b_idx].verified = data.valid
                }
            }
            this.checkConfigValidity()
        },
        getStatusConf(verified){
            return verified ? "done" : "failed"
        },
        async saveMaster(activate) {
            this.save_error = false
            if (activate) {
                this.c_master.active = true
            } else {
                this.c_master.active = false
            }
            this.c_master.is_conditional = this.is_conditional
            this.c_master.updated_by = this.$store.state.user._id
            this.c_master.blocks.splice(0, this.c_master.blocks.length)
            this.c_master.blocks.push(...this.selected_blocks)
            if(this.is_conditional){
                this.c_master.blocks.push(...this.selected_static_blocks)
            }
            this.c_master.updated = (new Date()).getTime()
            try {
                let res = await this.$store.state.$pouch.put('masters', this.c_master)
                if (res.ok) {
                    this.c_master._rev = res.rev
                    console.log("Update master " , res)
                    this.close()
                }
            } catch (error) {
                this.save_error = true
                console.log('error', error)
            }
            
        },
        async restore() {
            this.c_master = _.cloneDeep(this.o_master);
            this.selectPreviousBlocks()

        },
        close() {
            this.$router.push({path: '/admin/master/'})
        },
        checkConfigValidity() {
            let valid = false
            if (this.selected_blocks.length > 0) {
                valid = true
                for (let item of this.selected_blocks){
                    if (item.verified == undefined || !item.verified){
                        valid = false;
                        break
                    }
                }
                if (this.selected_static_blocks.length > 0) {
                    valid = true
                for (let item of this.selected_static_blocks){
                    if (item.verified == undefined || !item.verified){
                        valid = false;
                        break
                        }
                    }
                }
            }
            this.blocksValidity = valid
        }
    },
    computed: {
        enabledBlockSelection() {
            return (!!this.c_master.family && !!this.c_master.op_type)
        },
        configurationReady(){
            if(this.dynamic_blocks_warning || this.static_blocks_warning){
                return true
            } else {
                return this.isBlocksSelected
            }
        },
        isBlocksSelected() {
            return this.selected_blocks.length == 0
        },
        valid() {
            this.checkConfigValidity()
            return this.validityRegistry && this.blocksValidity
        },
        is_conditional(){
            let pretest = this.selected_blocks.find((block) => {
                return block.conditional == true
            })
            return pretest ? true : false
        },
        static_blocks_warning(){
            for(let block of this.selected_static_blocks){
                if(block.block_type != "static"){
                    return true
                }
            }
            return false
        },
        dynamic_blocks_warning(){
            for(let block of this.selected_blocks){
                if(block.block_type == "static"){
                    return true
                }
            }
            return false
        },
        is_simple(){
            if(this.c_master && this.c_master.op_type == "iso_simple"){
                return true
            } else {
                return false
            }
        },
        is_VP(){
            if(this.c_master && this.c_master.op_type == "leg"){
                return true
            } else {
                return false
            }
        }
    },
    watch: {
       'c_master.master_rev': {
           async handler() {
               let res = await searchDesign(this.$store.state.$pouch, 'reports', 'reports/searchByData', 'key', ['master', this.m_id, this.c_master.master_rev], true)
               this.report_count = (res.length > 0) ? res[0].value : 0
            }
       }
    }
}
</script>

